import { useDocumentTitle } from 'client/utils/use-document-title';
import { LoadedProps, RouteLoadProps } from '@components/router';
import { rpx } from 'client/lib/rpx-client';
import { AsyncForm } from '@components/async-form';
import { useState } from 'preact/hooks';
import { BtnPrimary, Button } from '@components/buttons';
import { IcoArrowRight, IcoArrowLeft } from '@components/icons';
import { InputField } from '@components/calendar-form';
import { defCalRoute } from './common';
import { LoginWrapper, FormHeader } from './components/login-wrapper';

export const route = defCalRoute({ isPublic: true, Page, load });

type Props = LoadedProps<typeof load>;

async function load(route: RouteLoadProps) {
  const { email } = route.params;
  if (!email) {
    return { email: '' };
  }
  return { email };
}

function Page({ state }: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [email, setEmail] = useState(state.email || '');
  const [emailSent, setEmailSent] = useState(false);

  useDocumentTitle(['Forgot Password']);

  async function sendSignInLink() {
    setIsSubmitting(true);
    try {
      await rpx.auth.calendarForgotPassword({ email: email, mode: 'forgot' });
      setEmailSent(true);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <LoginWrapper>
      {emailSent && (
        <div class="flex flex-col w-full max-w-96">
          <FormHeader
            title="We sent you a magic link!"
            subtitle={
              <>Check the inbox for {email}, and click the link there to continue signing up.</>
            }
          />
        </div>
      )}
      {!emailSent && (
        <div class="flex flex-col w-full max-w-96 gap-6">
          <FormHeader title="CoachMira" />
          <AsyncForm class="flex flex-col gap-6 w-full max-w-80 mx-auto" onSubmit={sendSignInLink}>
            <InputField
              name="email"
              fullWidth
              autoFocus
              title="Email address"
              placeholder="you@example.com"
              value={email}
              onInput={(e: any) => setEmail(e.target.value)}
            />
            <BtnPrimary
              class="gap-2 items-center p-4 rounded-full text-base min-w-40 mt-2"
              isLoading={isSubmitting}
            >
              Email sign in link
              <IcoArrowRight class="size-4 shrink-0" />
            </BtnPrimary>

            <Button
              href={`/calendar/login?email=${encodeURIComponent(email)}`}
              class="flex mx-auto items-center gap-2 text-indigo-600 focus-within:outline-current outline-2 outline-transparent focus-within:shadow-none focus:outline-none"
            >
              <IcoArrowLeft class="size-4 shrink-0" /> Sign in
            </Button>
          </AsyncForm>
        </div>
      )}
    </LoginWrapper>
  );
}
